module.exports = __webpack_public_path__ + "static/media/35.aa2d4b7b.png";